class Invitation {

    constructor() {
        let onAnimate = function() {
            $('.vacancy-invitation:in-viewport').each((i,el)=> {
                $(el).isInViewport({tolerance: -275}).each(()=> {
                    $(window).off('scroll', onAnimate);
                    window.gaCounter('send', 'event', 'feedback_block', 'show', $('.vacancy-promo__title').text());
                });
            });
        };

        $(window).on('scroll', onAnimate);

        $(document).on('ga:clientID', function (e, clientID) {
            $('.js-form-cid').val(clientID);
        });
    }
}

let invitation = new Invitation();

export default invitation;
